export enum TOKEN {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  KC_TOKEN = 'id_token',
}
